<template>
  <div class="calico-navigation-tab-page">
    <div class="container">
      <div class="row">
        <!-- Default -->
        <calico-navigation-tab to="/calico/navigationTab">
          <i class="bi bi-house-door" />
          <label class="label--medium">
            Default
          </label>
        </calico-navigation-tab>

        <!-- Default Disabled -->
        <calico-navigation-tab
          to="/nothing"
          :disabled="true"
        >
          <i class="bi bi-house-door" />
          <label class="label--medium">
            Default Disabled
          </label>
        </calico-navigation-tab>

        <!-- Alt -->
        <calico-navigation-tab
          to="#alt"
          variant="alt"
        >
          <i class="bi bi-circle-square" />
          <label class="label--medium">
            Alt Navigation
          </label>
        </calico-navigation-tab>

        <!-- Alt Disabled -->
        <calico-navigation-tab
          to="#alt-disabled"
          variant="alt"
          :disabled="true"
        >
          <i class="bi bi-circle-square" />
          <label class="label--medium">
            Alt Navigation
          </label>
        </calico-navigation-tab>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoNavigationTab from '@/components/calico/navigationTab/index.vue';

export default {
  name: 'CalicoNavigationTabView',
  components: {
    CalicoNavigationTab
  },
};
</script>

<style lang="scss" scoped>
.calico-navigation-tab-page {
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;

    .row {
      @include inline-space($space-large);
      @include inset-space($space-large);
      width: 100%;
    }
  }
}
</style>
